import { loadModuleDirectly } from '../../@Util/DependencyInjection/Injection/DependencyInjection';
import { CurrentUserStore } from '../../@Component/Domain/User/CurrentUserStore';

export default function hasPack(packCode: string)
{
    const currentUserStore = loadModuleDirectly(CurrentUserStore);

    return currentUserStore.packCodes.has(packCode);
}
